export const MAX_RENDER_PIXELS = 3840 * 2160;

export function calculateRenderScale(width: number, height: number, devicePixelRatio: number) {
  const cssPixels = Math.max(1, width * height);
  const pixelBudgetScale = Math.sqrt(MAX_RENDER_PIXELS / cssPixels);
  return Math.max(0.75, Math.min(devicePixelRatio || 1, 2, pixelBudgetScale));
}
